














































import Vue, { PropType } from 'vue';
import Component from 'vue-class-component';
import { Prop, Ref } from 'vue-property-decorator';
import { BulletinEntity } from '@/entities/bulletin.entity';

@Component<WatchingVideoBulletin>({})
export default class WatchingVideoBulletin extends Vue {
  @Prop({ type: Object as PropType<BulletinEntity> })
  bulletin: BulletinEntity;

  @Ref('refVideo') refVideo: InstanceType<typeof HTMLVideoElement>;

  dialog = false;

  handleClickOutSide() {
    this.refVideo.pause();
    this.dialog = false;
  }
}
